export default __webpack_public_path__ + "static/media/brands.5c20a28e.png";